var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-symbol",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M32.735,13.446a.266.266,0,0,1,.266.266V16.5A16.5,16.5,0,1,1,27.974,4.642a.266.266,0,0,1,0,.38L24.033,8.967a.265.265,0,0,1-.37.005,10.39,10.39,0,1,0,2.771,10.582H16.766a.266.266,0,0,1-.266-.266V13.711a.266.266,0,0,1,.266-.266H32.735Z",
    transform: "translate(0 0)",
    fill: "#2196f3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(15.503 13.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M257.762,208.612H255.77a.266.266,0,0,1,.266.266v2.789a16.486,16.486,0,0,1-15.505,16.47q.437.026.881.029a16.487,16.487,0,0,0,16.616-16.5v-2.789A.266.266,0,0,0,257.762,208.612Z",
    transform: "translate(-240.531 -208.612)",
    fill: "#1e88e5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M36.823,12.148,31.812,8.528A16.5,16.5,0,0,1,57.735,4.642a.266.266,0,0,1,0,.38L53.794,8.967a.265.265,0,0,1-.369.006,10.393,10.393,0,0,0-16.6,3.175Z",
    transform: "translate(-29.762 0)",
    fill: "#f44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M87.115,99.771l1.447,1.045a10.4,10.4,0,0,1,8.358-5.983L97,94.824q-.491-.047-.994-.047A10.36,10.36,0,0,0,87.115,99.771Z",
    transform: "translate(-81.5 -88.668)",
    fill: "#e53935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M251.023,4.642a.266.266,0,0,1,0,.38l-3.2,3.2a10.441,10.441,0,0,1,.879.748.265.265,0,0,0,.37-.005l3.945-3.945a.266.266,0,0,0,0-.38A16.449,16.449,0,0,0,241.541,0c-.335,0-.667.011-1,.031A16.447,16.447,0,0,1,251.023,4.642Z",
    transform: "translate(-225.041 0)",
    fill: "#e53935"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M53.845,323.44a16.5,16.5,0,0,1-26.865-3.834L32.1,316.1a10.393,10.393,0,0,0,16.738,3.72Z",
    transform: "translate(-25.241 -295.726)",
    fill: "#4caf50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M84.459,316.1l-1.509,1.034a10.39,10.39,0,0,0,9.162,5.484c.335,0,.667-.016.994-.047A10.4,10.4,0,0,1,84.459,316.1Z",
    transform: "translate(-77.604 -295.727)",
    fill: "#43a047"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M241.579,422.393a16.454,16.454,0,0,0,12.1-5.287l-1.227-.887a16.47,16.47,0,0,1-11.87,6.143Q241.079,422.393,241.579,422.393Z",
    transform: "translate(-225.079 -389.393)",
    fill: "#43a047"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M6.109,140.278a10.36,10.36,0,0,0,.746,3.874l-5.116,3.506a16.526,16.526,0,0,1,.311-15.352l5.011,3.621a10.348,10.348,0,0,0-.953,4.352Z",
    transform: "translate(0 -123.778)",
    fill: "#ffc107"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M65.1,182.569l1.509-1.034a10.42,10.42,0,0,1,.207-8.225l-1.447-1.045a10.441,10.441,0,0,0-.268,10.3Z",
    transform: "translate(-59.754 -161.162)",
    fill: "#ffb300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon_google.bb0fe88eae02bb2d00f0c708e3254f4b.svg";
export { ForwardRef as ReactComponent };